import React from 'react';
import PropTypes from 'prop-types';

class Chart extends React.Component {
    static propTypes = {
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        margins: PropTypes.object.isRequired,
    }

    render() {
        const {
            margins,
            height,
            width,
            children,
        } = this.props;
        var t = `translate(${margins.left}, ${margins.top})`;

        return (
            <svg
                height = {height}
                width = {width}
            >
                <g
                     transform = {t}
                >
                    {children}
                </g>
            </svg>
        );
    }
};

export default Chart;
